/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content1/view.blocks to change it.
import * as fromData from 'Simple/Data'
import Content from './Content/index'
import No from './No/index'
import React from 'react'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function Content1({
  children,
  viewPath = "/App/Widget/Content/Questions/Complete/MedicalForm/Content/MedicalFormUrl/Content"
  
}) {
let leadPatientIdValueData = fromData.useDataValue({ viewPath,
context: 'lead',
path: 'patient_id',
})
  return (<React.Fragment
>
<No
  viewPath={`${viewPath}/No`}
/>
<Content
  viewPath={`${viewPath}/Content`}
/>
{children}
</React.Fragment>)
}